import { Table, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

const SensorTable = ({ sensors, loading, onEditSensor, onAddNewSensor }) => {
    if (loading) {
        return (
            <div className="text-center my-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (!sensors || sensors.length === 0) {
        return (
            <Container fluid>
                <Row className="mb-3">
                    <Col md={12} className="text-md-end">
                        <Button variant="primary" onClick={onAddNewSensor} className="mt-5">
                            Add a New Sensor
                        </Button>
                    </Col>
                </Row>
                <div className="alert alert-info">No sensors found</div>
            </Container>
        );
    }

    return (
        <Container fluid className="py-4">
            <Row className="mb-3">
                <Col md={12} className="text-md-end">
                    <Button
                        variant="primary"
                        onClick={onAddNewSensor}
                        className="mt-5"
                    >
                        <FontAwesomeIcon icon={faPlus} className="me-2" />
                        Add New
                    </Button>
                </Col>
            </Row>
            <h2 className="mb-4 fs-2">Sensors</h2>
            <Table striped bordered hover responsive>
                <thead className="table-striped">
                    <tr>
                        <th>#</th>
                        <th>Serial Number</th>
                        <th>Build Revision</th>
                        <th>Part Revision</th>
                        <th>Oil Type</th>
                        <th>Filter Thickness</th>
                        <th>Cavity</th>
                        <th>Description</th>
                        <th>Created</th>
                        <th>Updated</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {sensors && sensors.length > 0 ? (
                        sensors.map((sensor, index) => (
                            <tr key={sensor.id || index}>
                                <td>{index + 1}</td>
                                <td>{sensor.serial_number}</td>
                                <td>{sensor.build_revision}</td>
                                <td>{sensor.part_revision}</td>
                                <td>{sensor.oil_type}</td>
                                <td>{sensor.filter_thickness}</td>
                                <td>{sensor.cavity}</td>
                                <td>{sensor.sensor_description}</td>
                                <td>
                                    {new Date(sensor.created_at).toLocaleDateString()}
                                    <br />
                                    <small className="text-muted">
                                        {new Date(sensor.created_at).toLocaleTimeString()}
                                    </small>
                                </td>
                                <td>
                                    {sensor.updated_at ? (
                                        <>
                                        {new Date(sensor.updated_at).toLocaleDateString()}
                                        <br />
                                        <small className="text-muted">
                                            {new Date(sensor.updated_at).toLocaleTimeString()}
                                        </small>
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                                <td align="center">
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        title="Edit"
                                        onClick={() => onEditSensor(sensor)}
                                    >
                                        <><FontAwesomeIcon icon={faEdit}/></>
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ): (
						<tr>
							<td colSpan="6" className="text-center text-muted py-4"> No sensors added yet. </td>
						</tr>
					)}
                </tbody>
            </Table>

            <div className="d-flex justify-content-end mt-3 me-3">
				<span className="text-muted"> Showing {sensors?.length || 0} records </span>
			</div>
        </Container>
    );
};

export default SensorTable;